/**
 * Created by shubham on 20/11/18.
 */

import {BusinessUnitListPage} from "./businessUnitList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class BusinessUnitListPageData<T> {
    data = new Array<T>();
    page = new BusinessUnitListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/businessUnitList-datatable/businessUnitList-page-data.ts